import { useState } from 'react';
import clsx from 'clsx';
import Button from '@mui/material/Button';
import ABSSvgIcon from '@abs/core/ABSSvgIcon';
import Dialog from '@mui/material/Dialog';
import { useSelector } from 'react-redux';
import { selectABSCurrentSettings } from 'app/store/abs/settingsSlice';
import ABSHighlight from '@abs/core/ABSHighlight';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import qs from 'qs';
import Typography from '@mui/material/Typography';

function ABSSettingsViewerDialog(props) {
  const { className } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const settings = useSelector(selectABSCurrentSettings);

  function handleOpenDialog() {
    setOpenDialog(true);
  }

  function handleCloseDialog() {
    setOpenDialog(false);
  }

  return (
    <div className={clsx('', className)}>
      <Button
        variant="contained"
        color="secondary"
        className="w-full"
        onClick={handleOpenDialog}
        startIcon={<ABSSvgIcon>heroicons-solid:code</ABSSvgIcon>}
      >
        View settings as json/query params
      </Button>

      <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
        <DialogTitle className="">ABS Settings Viewer</DialogTitle>
        <DialogContent className="">
          <Typography className="text-16 font-bold mt-24 mb-16">JSON</Typography>

          <ABSHighlight component="pre" className="language-json">
            {JSON.stringify(settings, null, 2)}
          </ABSHighlight>

          <Typography className="text-16 font-bold mt-24 mb-16">Query Params</Typography>

          {qs.stringify({
            defaultSettings: JSON.stringify(settings, { strictNullHandling: true }),
          })}
        </DialogContent>
        <DialogActions>
          <Button color="secondary" variant="contained" onClick={handleCloseDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ABSSettingsViewerDialog;
